export default "__VITE_ASSET__0bb4401e__"